import { combineReducers } from 'redux';

import { createResourceModuleReducerMap } from 'medialoopster/rest';

import { TranscriptSpeakerRootState } from './types';

export default combineReducers<TranscriptSpeakerRootState>(
  createResourceModuleReducerMap('transcriptspeaker', 'speakers'),
);
